import { IonButton, IonIcon, IonModal } from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Zoom } from "swiper/modules";
import "swiper/css";
import "swiper/css/zoom";
import { ImageLoader } from "../ImageLoader";
import "./ImageViewerModal.css";

/**
 * One picture, full screen, pinch to zoom.
 *
 * The post gallery already had this (MultimediaInPost's fullscreen modal), but
 * it is built around a carousel of post slides — images, videos and files — and
 * carries the counter and arrows that come with them. A comment has exactly one
 * photo, so this is the same idea with nothing else attached.
 *
 * The single Swiper slide is not decoration: `swiper/css/zoom` plus the Zoom
 * module is what gives pinch and double-tap zoom, and ImageLoader's `zoom` prop
 * emits the `.swiper-zoom-container` wrapper it needs. Without them the picture
 * would only be bigger, not examinable — which is the point of opening it.
 */
export default function ImageViewerModal({ isOpen, src, onClose }) {
  if (!src) return null;

  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onClose}
      cssClass="ds-image-viewer-modal"
    >
      <div className="ds-image-viewer">
        <IonButton
          className="ds-image-viewer__close"
          fill="clear"
          onClick={onClose}
          aria-label="Chiudi"
        >
          <IonIcon icon={closeOutline} />
        </IonButton>

        <Swiper className="ds-image-viewer__swiper" modules={[Zoom]} zoom={true}>
          <SwiperSlide>
            <div className="ds-image-viewer__wrap">
              <ImageLoader image={src} css="ds-image-viewer__img" zoom={true} />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </IonModal>
  );
}
